import styled from 'styled-components';
import { colors, Text } from '../../../globalStyles';

export const Required = styled.span`
  color: ${colors.danger};
`;

export const FieldName = styled.label`
  display: block;
  font-weight: bold;
  color: ${colors.black};
`;

export const Caption = styled(Text.captionGrey)`
  line-height: 16px;
`;
